import React from 'react';
import Error404 from './../../templates/Error404.jsx'
import ImageErrorBlog from './../../images/errors 404/error-blog.svg'

const ErrorBlog = () => (
    < Error404 
        ImageError={ImageErrorBlog}
        Title="Este blog todavia no lo escribo porque da pereza 😂😂"
        Description="Pero si quieres que escriba un blog del tema que tienes en mente, pues no te quedes, intentalo, adelante escribeme en mi correo."
        LinkRedireccion="/contacto"
        TextRedireccion="Contacto"
    />
)

export default ErrorBlog;